import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XS01.error_id: {
            return (
                <>
                    <ResultText>
                        The cross-section cutlines of the following {row?.data?.length} cross sections intersect with other cross sections.
                        <EmptyLine />
                        <CheckCSName csNameList={row?.data?.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}


export const B15 = {
    RenderDescription,

}